export const tools = [
  {
    id: 1,
    title: "Visual Studio",
    description:
      "An integrated development environment (IDE) from Microsoft that is used to develop computer programs.",
    icon: "fas fa-desktop indigo-text pr-2",
  },

  {
    id: 2,
    title: "Github",
    description: "Code hosting platform for version control and collaboration.",
    icon: "fab fa-github  pr-2",
  },

  {
    id: 3,
    title: "MongoDB Atlast",
    description: "MongoDB Atlas is a fully-managed cloud database.",
    icon: "fas fa-leaf green-text pr-2",
  },

  {
    id: 1,
    title: "MongoDB Compass",
    description:
      " MongoDB Compass is the GUI for MongoDB. Compass allows you to analyze and understand the contents of the data.",
    icon: "fab fa-envira green-text pr-2",
  },

  {
    id: 4,
    title: "Firebase",
    description:
      "A Backend-as-a-Service (Baas) that provides developers with a variety of tools and services to help them develop quality apps.",
    icon: "fas fa-fire-alt red-text pr-2",
  },

  {
    id: 5,
    title: "Heroku",
    description:
      "Heroku is a cloud platform that lets companies build, deliver, monitor and scale apps.",
    icon: "fas fa-database pink-text pr-2",
  },

  {
    id: 6,
    title: "Robo3T",
    description:
      "Robo 3T (formerly Robomongo) is the free, lightweight, open-source MongoDB GUI with an embedded mongo shell and real auto-completion.",
    icon: "fas fa-robot green-text pr-2",
  },

  {
    id: 7,
    title: "Cloudflare",
    description:
      "An intelligent, integrated global cloud network that delivers security and performance.",
    icon: "fab fa-mixcloud orange-text pr-2",
  },

  {
    id: 8,
    title: "Cloudinary",
    description:
      "Cloudinary is an end-to-end image and video-management solution for websites and mobile apps.",
    icon: "fas fa-cloud blue-text pr-2",
  },

  {
    id: 9,
    title: "Postman2",
    description:
      "Postman is an API(application programming interface) development tool which helps to build, test and modify APIsCreate infographic and presentation.",
    icon: "fas fa-user-circle orange-text pr-2",
  },

  {
    id: 10,
    title: "MDBootstrap",
    description: "MDBootstrap stands for material design for bootstrap.",
    icon: "fab fa-mdb blue-text pr-2",
  },
  {
    id: 11,
    title: "ThingsBoard",
    description:
      "Open-source IoT platform for data collection, processing, visualization, and device management.",
    icon: "fas fa-wifi pink-text pr-2",
  },
  {
    id: 12,
    title: "SendGrid",
    description:
      "A cloud-based SMTP provider that allows you to send email without having to maintain email servers.",
    icon: "fas fa-paper-plane purple-text pr-2",
  },
  {
    id: 13,
    title: "Canva",
    description: "  Create infographic and presentation.",
    icon: "fas fa-rocket red-text pr-2",
  },
  {
    id: 14,
    title: "Figma",
    description:
      "   Figma is a browser-based UI and UX design application, with excellent design, prototyping, and code-generation tools. ",
    icon: "fab fa-figma pink-text pr-2",
  },
  {
    id: 15,
    title: "Draw.io",
    description:
      "draw.io is proprietary software for making diagrams and charts.",
    icon: "fas fa-palette orange-text pr-2",
  },
  {
    id: 16,
    title: "Source-Tree",
    description:
      " a free graphical user interface (GUI) desktop client that simplifies how you interact with Git repositories so that you can fully concentrate on coding",
    icon: "fas fa-tree green-text pr-2",
  },
  {
    id: 17,
    title: "Remix",
    description:
      "a powerful, open source tool that helps you write Solidity contracts straight from the browser.",
    icon: "fas fa-robot blue-text pr-2",
  },
  {
    id: 18,
    title: "Adobe XD",
    description:
      "a powerful and easy-to-use vector-based experience design platform that gives teams the tools they need to craft the world's best experiences collaboratively",
    icon: "fas fa-paint-roller pink-text pr-2",
  },
  {
    id: 19,
    title: "Jira",
    description:
      "a software application used for issue tracking and project management.",
    icon: "fab fa-jira blue-text pr-2",
  },
  {
    id: 20,
    title: "Microsoft Team",
    description:
      "cloud-based team collaboration software that is part of the Microsoft 365 and Office 365 suite of applications.",
    icon: "fab fa-windows blue-text pr-2",
  },
];
